<div class="modal-header d-flew flex-row justify-content-between align-items-center">
  <mdb-icon
    fas
    *ngIf="currentStep !== TRANSPORT_STEP.SETTING && transportFormGroup.controls.items.length === 0"
    class="cursor-pointer mx-2 text-black-50"
    icon="chevron-left"
    (click)="returnStep()"
  ></mdb-icon>
  <h5 class="modal-title flex-grow-1 text-center">
    {{ (currentStep === TRANSPORT_STEP.SETTING ? 'BARY_LIGHT_ESTIMATE.LABEL.DIMENSIONS' : 'MODAL_ESTIMATE.TITLE') | translate }}
  </h5>
  <mdb-icon class="cursor-pointer mx-2 text-black-50 fas fa-lg" icon="close" (click)="handleClick({ close: true })"></mdb-icon>
</div>

<div class="modal-body px-0">
  <jhi-bary-offer-form *ngIf="currentStep === TRANSPORT_STEP.SETTING" [formGroup]="transportFormGroup.getAngularForm()" [isOffer]="false"> </jhi-bary-offer-form>
  <jhi-transport-estimation-step
    *ngIf="currentStep === TRANSPORT_STEP.ITEM && transportItemForm"
    [dimensionOpts]="dimensionOpts"
    [handlingTypes]="handlingTypesOpt"
    [formGroup]="transportItemForm"
    [transportFormGroup]="transportFormGroup"
  ></jhi-transport-estimation-step>
  <jhi-transport-extra-condition-form *ngIf="currentStep === TRANSPORT_STEP.SPECIAL" [transportForm]="transportFormGroup"></jhi-transport-extra-condition-form>
</div>

<div class="modal-footer pt-4">
  <ng-container *ngIf="currentStep === TRANSPORT_STEP.SETTING">
    <jhi-bary-button [outline]="true" size="sm" [label]="'BTN.CANCEL' | translate" (clickEvent)="handleClick({ close: true })"></jhi-bary-button>
    <jhi-bary-button (clickEvent)="nextStep()" size="sm" class="ml-2" [label]="'BTN.CONFIRM' | translate" color="primary"></jhi-bary-button>
  </ng-container>

  <ng-container *ngIf="currentStep === TRANSPORT_STEP.ITEM">
    <div class="info-footer flex-grow-1 flex-column flex-lg-row d-flex">
      <div class="mx-0 flex-grow-1">{{ 'LABEL.WEIGHT_TOTAL' | translate: { value: (weightTotal | number: '1.0-2') || '-' } }}</div>
      <div class="mx-0 mx-lg-2 flex-grow-1">{{ 'LABEL.VOLUME_TOTAL' | translate: { value: (volumeTotal | number: '1.0-2') || '-' } }}</div>
      <div class="mx-0 flex-grow-1">{{ 'LABEL.LDM_TOTAL' | translate: { value: (ldmTotal | number: '1.0-2') || '-' } }}</div>
      <div class="mx-0 flex-grow-1" *ngIf="transportItemForm?.controls['handlingType']?.value === CRATE_OF_WINE">
        {{ 'LABEL.EQ_BOTTLES' | translate: { number: transportItemForm?.controls['otherSpecificQuantity']?.value || '-' } }}
      </div>
    </div>
    <jhi-bary-button (clickEvent)="handleClick(true)" size="sm" class="ml-2" [label]="'BTN.CONFIRM' | translate" color="primary"></jhi-bary-button>
  </ng-container>

  <ng-container *ngIf="currentStep === TRANSPORT_STEP.SPECIAL">
    <jhi-bary-button
      size="sm"
      [disabled]="transportFormGroup.getAngularForm().controls['transportExtraConditions'].value?.length === 0"
      (clickEvent)="nextStep()"
      class="ml-2"
      [label]="'BTN.CONTINUE' | translate"
      color="primary"
    ></jhi-bary-button>
  </ng-container>
</div>
